import Space from "./Space";
import { ReactNode } from "react";
import Defines from "../util/Defines";
import { ColorHexCodes } from "../util/Color";
import { StyledText } from "./StyledText";
import { Stack } from "@mui/material";
import checkIcon from "../img/check.png";

function getItemLabels(skipConfirm?: boolean) {
  const thirdItem = skipConfirm ? ["ご予約確定"] : ["ご予約内容", "の確認"];
  const itemLabels = [["店舗と日時", "の選択"], ["ご予約受付"], thirdItem];
  return itemLabels;
}

export function FormWrapper({ children, currentIndex, skipConfirm }: { children: ReactNode; currentIndex: number; skipConfirm?: boolean }) {
  const itemLabels = getItemLabels(skipConfirm);
  const progressItems = itemLabels.map((label, i) => <ProgressItem key={i} itemIndex={i} progressIndex={currentIndex} itemLabels={itemLabels} />);
  return (
    <Stack style={{ backgroundColor: `#${ColorHexCodes.HeaderBackGround}` }}>
      <div style={{ fontSize: "26px", textAlign: "center" }}>{currentIndex < 4 ? "ご予約受付" : "ご予約完了"}</div>
      <Space h={5} />
      <Stack direction={"row"} style={{ paddingRight: 40 ,paddingLeft: 40 }}>{progressItems}</Stack>
      <Space h={10} />
      <Stack style={{ backgroundColor: "white", padding: "20px 30px 0px 30px" }}>
        {(() => {
          if (currentIndex < 4) {
            return <Stack style={{ fontSize: 18, color: `#${ColorHexCodes.MainColorGreen}` }}>{itemLabels[currentIndex].join("")}</Stack>
          } else {
            return (
              <Stack style={{ alignItems: "center" }}>
                <StyledText textStyle="ReservationCompleted">{"予約が完了しました"}</StyledText>
                <StyledText textStyle="ReservationCompletedMessage">{"ご予約いただき、誠にありがとうございます。予約完了の確定メールを送信いたしましたので、必ず予約内容をご確認ください。"}</StyledText>
              </Stack>
            );
          }
        })()}
        <Space h={5} />
        <Stack style={{ height: 1, background: `#${ColorHexCodes.MainColorGreen}` }} />
        <Space h={10} />
        {children}
      </Stack>
    </Stack>
  );
}

function ProgressItem({ itemIndex, progressIndex, itemLabels }: { itemIndex: number; progressIndex: number; itemLabels: string[][] }) {
  let mainColor = `#${ColorHexCodes.MainColorGreen}`;
  let subColor = "transparent";
  let indexColor = `#${ColorHexCodes.MainColorGreen}`;
  let textColor = `#${ColorHexCodes.MainColorGreen}`;
  if ( itemIndex < progressIndex ) {
    subColor = `#${ColorHexCodes.MainColorGreen}`;
  } else if ( itemIndex > progressIndex ) {
    mainColor = "lightGray";
    subColor = "lightGray";
    indexColor = "white";
    textColor = "gray";
  }
  const leftLineColor = itemIndex === 0 ? "transparent" : mainColor;
  const rightLineColor = (function () {
    if (itemIndex === itemLabels.length - 1) {
      return "transparent";
    }
    if (progressIndex <= itemIndex) {
      return "lightGray";
    } else {
      return Defines.PrimaryColor;
    }
  })();
  const insideCircle = (() => { 
    if (itemIndex < progressIndex) {
      return (
        <Stack sx={{ alignItems: "center", justifyContent: "center" }}>
          <img width={16} height={16} style={{ objectFit: "contain" }} src={checkIcon} />
        </Stack>
      );
    }
    return <div style={{ color: indexColor, lineHeight: "100%" }}>{itemIndex + 1}</div>;
  })()

  return (
    <Stack style={{ flexGrow: 1 }}>
      <Stack direction={"row"} style={{ alignItems: "center" }}>
        <div style={{ flexGrow: 1, height: 2, backgroundColor: leftLineColor }} />
        <Space w={5} />
        <Stack
          style={{
            width: 30,
            height: 30,
            background: subColor,
            borderRadius: "50%",
            justifyContent: "center",
            alignItems: "center",
            border: "3px solid " + mainColor,
            color: "white",
          }}
        >
          {insideCircle}
        </Stack>
        <Space w={5} />
        <div style={{ flexGrow: 1, height: 2, backgroundColor: rightLineColor }} />
      </Stack>
      <Space h={5} />
      {
        <div
          style={{
            margin: "0 12px",
            textAlign: "center",
            color: textColor,
            fontSize: 12,
            fontWeight: "bold"
          }}
        >
          {itemLabels[itemIndex][0]}
        </div>
      }
    </Stack>
  );
}

function FractionCircle({ num, den }: { num: number; den: number }) {
  const angle = (360 * num) / den;
  const size = 50;
  return (
    <div style={{ width: size, height: size, position: "relative" }}>
      <div style={{ position: "absolute", width: size, height: size, borderRadius: "50%", background: `#${ColorHexCodes.Gray}` }} />
      <div
        style={{
          position: "absolute",
          width: size,
          height: size,
          borderRadius: "50%",
          background: `conic-gradient(${Defines.PrimaryColor} ${angle}deg,transparent ${angle}deg)`,
        }}
      />
      <div style={{ position: "absolute", left: 3, top: 3, width: size - 6, height: size - 6, borderRadius: "50%", background: "white" }} />
      <Stack style={{ position: "absolute", width: size, height: size, justifyContent: "center", alignItems: "center" }}>
        <div style={{ fontSize: 25, color: Defines.PrimaryColor }}>{num}</div>
      </Stack>
    </div>
  );
}
